import global from '../web-sh/src/config/global'
import keys from './keys'
import constants from './constants'
import patterns from './patterns'
import rules from './rules'
import endpoint from './endpoint'
import urls from './urls'
import routers from './routers'
import menus from './menus'
import store from '../store'

global.keys = keys
global.constants = constants
global.patterns = patterns
global.rules = rules
global.endpoint = endpoint
global.urls = urls
global.routers = routers
global.menus = menus
global.store = store

export default global